import { withStyles } from '@material-ui/core';
import ReceiptPaymentField from './ReceiptPaymentField';
import styles from './ReceiptPaymentField.styles';

export default withStyles(styles)(ReceiptPaymentField);
